// Screen `recording` (owner: meeting-recorder, owner feedback F15): one recorded meeting with its player, notes,
// transcript and details. `?t=<seconds>` (milliseconds as decimals) opens the transcript at that moment.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RecordingPage } from '../../../../features/recorder/RecordingPage';
import { ModuleGate } from '../../../../shell/ModuleGate';

export const Route = createFileRoute('/_app/meetings/recordings/$id')({
  validateSearch: z.object({
    tab: z.enum(['notes', 'transcript', 'details']).optional().catch(undefined),
    t: z.coerce.number().min(0).max(86_400).optional().catch(undefined),
  }),
  component: function RecordingRoute() {
    const { id } = Route.useParams();
    const search = Route.useSearch();
    return (
      <ModuleGate module="recorder">
        <RecordingPage id={id} search={search} />
      </ModuleGate>
    );
  },
});
